import { trackingAdapter } from 'src/app/shared/dataAnalytics/analyticsAdapterFactory';
import { retrieveTrackingData } from 'src/app/shared/dataAnalytics/storage';
import { store } from 'src/app/v1/state/store';
import type { Tealium } from 'src/types/appState';

/**
 * This function merges existing redux state and stored data in session storage
 * This is required to move away from redux but still have access to the tealium state
 * This should be deprecated once we completed migration to session storage
 * @returns merged state from redux and session storage
 */
export const getMergedState = (): Tealium => {
  const state = store.getState();
  const storedTrackingData = retrieveTrackingData();

  return {
    ...state.tealium,
    ...storedTrackingData,
  };
};

export default trackingAdapter({ getTrackingData: getMergedState });

export const getPaymentsTrackingAdapter = () => {
  const sendPageEvent = () => {
    trackingAdapter({ getTrackingData: getMergedState }).sendPageEvent();
  };
  const sendLinkEvent = (
    eventName: string,
    eventAttributes?: Record<string, unknown>,
  ) => {
    trackingAdapter({ getTrackingData: getMergedState }).sendLinkEvent({
      eventName,
      ...eventAttributes,
    });
  };
  return {
    sendPageEvent,
    sendLinkEvent,
  };
};
